/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { S as Switch, d as defineCustomElement$1 } from './switch.js';

const CalciteSwitch = Switch;
const defineCustomElement = defineCustomElement$1;

export { CalciteSwitch, defineCustomElement };
